import "./TextCarousel.css";

const messages = [
    {
      text: "🧠 People may be more likely to believe disinformation if it aligns with pre-existing beliefs, provokes an emotional response, comes from a source they trust or if they are repeatedly exposed to it.",
      link: "https://commonslibrary.parliament.uk/disinformation-and-its-effects-on-society/"
    },
    {
      text: "📰 Over a quarter (26%) of reporters have unknowingly reported on stories later proven untrue.",
      link: "https://redline.digital/fake-news-statistics/"
    },
    {
      text: "📊 Younger groups consume more news videos through social networks but are less likely to access videos through news websites or applications.",
      link: "https://redline.digital/fake-news-statistics/"
    },
    {
      text: "📽️ There are 3x more video deepfakes and 8x more voice deepfakes in 2023 vs. 2022.",
      link: "https://redline.digital/fake-news-statistics/"
    },
    {
      text: "🚨 More than 90% of UK population have encountered misinformation online.",
      link: "https://www.turing.ac.uk/news/more-90-uk-population-have-encountered-misinformation-online"
    },
    {
        text: "🔁 To thrive in the digital age, individuals must view critical thinking as a lifelong skill, one that requires continuous refinement.",
        link: "https://www.turing.ac.uk/news/more-90-uk-population-have-encountered-misinformation-online"
      },
    {
        text: "🤖 Bots account for up to 66% of accounts spreading COVID-19 misinformation.",
        link: "https://redline.digital/fake-news-statistics/"
      }
  ];
  
  export default function TextCarousel() {
    const repeated = [...messages, ...messages];
  
    return (
      <div className="carouselContainer">
        <div className="tickerWrapper">
        <div className="tickerContent">
            {[...messages, ...messages].map((msg, index) => (
                <a href={msg.link} target="_blank" rel="noopener noreferrer" className="tickerItem" key={index}>
                    {msg.text} &nbsp;&nbsp;&nbsp;
                </a>
            ))}

            {[...messages, ...messages].map((msg, index) => (
                <a href={msg.link} target="_blank" rel="noopener noreferrer" className="tickerItem" key={index}>
                    {msg.text} &nbsp;&nbsp;&nbsp;
                </a>
            ))}
        

            </div>
        </div>
      </div>
    );
  }